import React from 'react'
import { displayYen } from '@/libs/text'
import { SpaceDetail } from '@/features/space/spaces-slice'
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { minScreen } from '@/styles/media-query'

export const SpacePriceLabel: React.FC<{ space: SpaceDetail }> = ({ space }) => {
  const { t } = useTranslation()

  const hasUnitPrice: boolean = (space.spacePrice?.chargePrice?.unitPrice || 0) > 0
  const hasMaxPrice: boolean = (space.spacePrice?.chargePrice?.maxPrice || 0) > 0

  return (
    <div
      css={css({
        paddingTop: 16,
        display: 'flex',
        alignItems: 'baseline',
        div: {
          letterSpacing: 1,
          fontSize: 10,
          fontWeight: 'normal',
          [minScreen()]: {
            fontSize: 12,
          },
        },
        span: {
          letterSpacing: 1.6,
          fontSize: 16,
          fontWeight: 'bold',
        },
      })}
    >
      {!hasUnitPrice && (hasMaxPrice ? <span>{displayYen(space.spacePrice!.chargePrice.maxPrice!.toString())}</span> : <span>¥-</span>)}
      {hasUnitPrice && (
        <>
          <span>
            {displayYen(space.spacePrice!.chargePrice.unitPrice!.toString())}
            {!space.isFixAvailabilityTime && '~'}
          </span>
          {!space.isFixAvailabilityTime && <div>／{t('hour')}</div>}
          {hasMaxPrice && (
            <div>
              ({t('maximum charge')}：{displayYen(space.spacePrice!.chargePrice.maxPrice!.toString())})
            </div>
          )}
        </>
      )}
    </div>
  )
}
